module.exports = require("@web3auth/ethereum-provider");